<template>
  <section class="green-room">
    <div class="green-room__padding">
      <div class="green-room__stage">
        <section class="page-area">


          <!-- Intro -->
          <div class="page page--0" v-if="currentPage === 0">
            <div class="page__background">

              <div class="page__targets--green_room_info" id="hide1" 
              @mouseover="hover0 = true, click(), hide_targets()"
              @mouseleave="show_targets()" :class="{ active: hover0 }"
              >
              </div>

              <div class="page__targets--you_cant_take" id="hide2" 
              @mouseover="hover = true, click()"
              @mouseleave="hover = false" :class="{ active: hover }"
              >
                </div>

              <div class="page__targets--book" id="hide3" 
              @mouseover="hover2 = true, click()"
              @mouseleave="hover2 = false" :class="{ active: hover2 }"
              >
                </div>

              <div class="page__targets--flyer" id="hide4" 
              @mouseover="hover3 = true, click()"
              @mouseleave="hover3 = false" :class="{ active: hover3 }"
              >
                </div>

              <div class="page__targets--audition" @click=nextPage></div>

              <div class="wrap" v-if="hover0">
                <div class="page__popup">
                  <div class="page__popup--green_room_info" id="intro" 
                  @mouseover="hover0 = true, hide_targets()"
                  @mousedown="show_targets()">
                    <div class="content" id="question">
                      <div class="text_box">
                        <div class="title">
                          <p>Why is it called a Green Room?</p>
                        </div>
                        <div class="details">
                          <p @click=answer><span>A.</span> Actors needed to rest their eyes after being under the harsh
                            stage lights,
                            and green is a soothing color.</p>
                          <p @click=answer><span>B.</span> It's a room where fake grass used to be stored, and grass is
                            green.</p>
                          <p @click=answer><span>C.</span> Because early stage lights were greenish in color, the
                            actors painted
                            their faces green to match!</p>
                          <p @click=answer><span>D.</span> In Renaissance times plays were held on the tennis courts,
                            which were
                            grass, so the playing area was called "the green." Actors waited to go onstage in the "green
                            room".</p>
                          <p @click=answer><span>E.</span> All of the above.</p>

                        </div>
                      </div>
                    </div>

                    <div class="content_answer" id="answer">
                      <div class="text_box">
                        <div class="title">
                          <p>Why is it called a Green Room?</p>
                        </div>
                        <div class="details">
                          <p class="subtitle">Answer</p>
                          <p><span>E.</span> All of the above, or maybe none of the above. Nobody really knows!</p>
                          <div class="button_box">
                            <div class="close" @click="intro_close(), show_targets()">
                              <p>close</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wrap" v-if="hover">
                <div class="page__popup">
                  <div class="page__popup--you_cant_take">
                    <div class="content">
                      <div class="content_image"></div>
                      <div class="text_box">
                        <div class="title">
                          <p>The Proscenium Stage</p>
                        </div>
                        <div class="details">
                          <p>The most familiar type of theater is the proscenium stage, named for the proscenium arch
                            that
                            surrounds the stage opening like a picture frame.</p>

                          <p>Other types of stages include the ARENA STAGE, or theater-in-the-round, where the audince
                            sits on all sides, and the THRUST STAGE, that extends into the seating area.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wrap" v-if="hover2">
                <div class="page__popup">
                  <div class="page__popup--book">
                    <div class="content">
                      <div class="text_box">
                        <div class="title">
                          <p>Body Positions</p>
                        </div>
                        <div class="details">
                          <p>How an actor stands on a proscenium stage in relation to the audience is called the body
                            position. Each position has a name.</p>
                        </div>
                      </div>
                      <div class="content_image"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wrap" v-if="hover3">
                <div class="page__popup">
                  <div class="page__popup--flyer">
                    <div class="content">
                      <div class="text_box">
                        <div class="title">
                          <p>Acting Areas</p>
                        </div>
                        <div class="details">
                          <p>Proscenium stages area divided into acting areas. the terms downstage and upstage come from
                            the days when the rear of the stage was tilted, or raked, upward, and away from the
                            audience.</p>
                        </div>
                      </div>
                      <div class="content_image"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- The Audition - Juliet -->
          <div class="page page--1" v-if="currentPage === 1">
            <div class="page__page-area">

              <div class="page__popup" id="juliet">
                <div class="page__popup--juliet_audition">
                  <div class="content">
                    <div class="text_box">
                      <div class="title">
                        <p>The Audition</p>
                        <p id="close" @click="close1">X</p>
                      </div>
                      <div class="details">
                        <p>The director must cast or choose two actors to play the roles of Juliet and Romeo. There are
                          three actors auditioning or trying out for each role.</p>
                        <p>Auditions for Juliet will be heard first. To get started, <span>close this window</span> and
                          click on the back of the actor's chair. Listen to the actor's audition on stage and select the
                          actor that best fits the role.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__popup" id="juliet1_popup">
                <div class="page__popup--juliet1_popup">
                  <div class="content">
                    <div class="content_image"></div>
                    <div class="text_box">
                      <div class="title">
                        <p>Juliet</p>
                      </div>
                      <div class="details">
                        <p>You have cast an actress to play Juliet. You may select another actress or continue to the
                          audition for Romeo.</p>
                      </div>
                      <div class="button_box">
                        <div class="back" @click="juliet_reset">
                          <p>Go Back</p>
                        </div>
                        <div class="continue" @click="nextPage(), juliet_value = 1">
                          <p>Continue</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__popup" id="juliet2_popup">
                <div class="page__popup--juliet2_popup">
                  <div class="content">
                    <div class="content_image"></div>
                    <div class="text_box">
                      <div class="title">
                        <p>Juliet</p>
                      </div>
                      <div class="details">
                        <p>You have cast an actress to play Juliet. You may select another actress or continue to the
                          audition for Romeo.</p>
                      </div>
                      <div class="button_box">
                        <div class="back" @click="juliet_reset">
                          <p>Go Back</p>
                        </div>
                        <div class="continue" @click="nextPage(), juliet_value = 2">
                          <p>Continue</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__popup" id="juliet3_popup">
                <div class="page__popup--juliet3_popup">
                  <div class="content">
                    <div class="content_image"></div>
                    <div class="text_box">
                      <div class="title">
                        <p>Juliet</p>
                      </div>
                      <div class="details">
                        <p>You have cast an actress to play Juliet. You may select another actress or continue to the
                          audition for Romeo.</p>
                      </div>
                      <div class="button_box">
                        <div class="back" @click="juliet_reset">
                          <p>Go Back</p>
                        </div>
                        <div class="continue" @click="nextPage(), juliet_value = 3">
                          <p>Continue</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="js1_target" class="page__targets--juliet1" @click='j1(), j1_selected()' @touchstart= 'j1(), j1_selected()'></div>
              <div id="js2_target" class="page__targets--juliet2" @click='j2(), j2_selected()'></div>
              <div id="js3_target" class="page__targets--juliet3" @click='j3(), j3_selected()'></div>
              <div id="js1" class="page__juliet_stage1"></div>
              <div id="js2" class="page__juliet_stage2"></div>
              <div id="js3" class="page__juliet_stage3"></div>
              <div id="all" class="page__juliets"></div>
              <div id="j1" class="page__juliet_1_missing"></div>
              <div id="j2" class="page__juliet_2_missing"></div>
              <div id="j3" class="page__juliet_3_missing"></div>
              <p id="text1" @click="j1_text">select</p>
              <p id="text2" @click="j2_text">select</p>
              <p id="text3" @click="j3_text">select</p>
              <div id="c1" class="page__light"></div>
              <div id="c2" class="page__dark"></div>
            </div>
          </div>

          <!-- The Audition - Romeo -->
          <div class="page page--2" v-show="currentPage === 2">
            <div class="page__page-area">

              <div class="page__popup" id="romeo">
                <div class="page__popup--romeo_audition">
                  <div class="content">
                    <div class="text_box">
                      <div class="title">
                        <p>The Audition</p>
                        <p id="close" @click="close2">X</p>
                      </div>
                      <div class="details">
                        <p>Now it's time to choose who will be cast in the Romeo role. <span> Close this window</span>
                          and click on the back of the actor's chair. Listen to the actor's audition on stage and select
                          the actor that best fits the role.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__popup" id="romeo1_popup">
                <div class="page__popup--romeo1_popup">
                  <div class="content">
                    <div class="content_image"></div>
                    <div class="text_box">
                      <div class="title">
                        <p>Romeo</p>
                      </div>
                      <div class="details">
                        <p>You have cast an actor to play Romeo. You may select another actor or continue to the
                          performance.</p>
                      </div>
                      <div class="button_box">
                        <div class="back" @click="romeo_reset">
                          <p>Go Back</p>
                        </div>
                        <div class="continue" @click="nextPage(), romeo_value = 1 , performance()">
                          <p>Continue</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__popup" id="romeo2_popup">
                <div class="page__popup--romeo2_popup">
                  <div class="content">
                    <div class="content_image"></div>
                    <div class="text_box">
                      <div class="title">
                        <p>Romeo</p>
                      </div>
                      <div class="details">
                        <p>You have cast an actor to play Romeo. You may select another actor or continue to the
                          performance.</p>
                      </div>
                      <div class="button_box">
                        <div class="back" @click="romeo_reset">
                          <p>Go Back</p>
                        </div>
                        <div class="continue" @click="nextPage(), romeo_value = 2, performance()">
                          <p>Continue</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page__popup" id="romeo3_popup">
                <div class="page__popup--romeo3_popup">
                  <div class="content">
                    <div class="content_image"></div>
                    <div class="text_box">
                      <div class="title">
                        <p>Romeo</p>
                      </div>
                      <div class="details">
                        <p>You have cast an actor to play Romeo. You may select another actor or continue to the
                          performance.</p>
                      </div>
                      <div class="button_box">
                        <div class="back" @click="romeo_reset">
                          <p>Go Back</p>
                        </div>
                        <div class="continue" @click="nextPage(), romeo_value = 3, performance()">
                          <p>Continue</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="rs1_target" class="page__targets--romeo1" @click='r1(), r1_selected()'></div>
              <div id="rs2_target" class="page__targets--romeo2" @click='r2(), r2_selected()'></div>
              <div id="rs3_target" class="page__targets--romeo3" @click='r3(), r3_selected()'></div>
              <div id="rs1" class="page__romeo_stage1"></div>
              <div id="rs2" class="page__romeo_stage2"></div>
              <div id="rs3" class="page__romeo_stage3"></div>
              <div id="all" class="page__romeos"></div>
              <div id="r1" class="page__romeo_1_missing"></div>
              <div id="r2" class="page__romeo_2_missing"></div>
              <div id="r3" class="page__romeo_3_missing"></div>
              <p id="text4" @click="r1_text">select</p>
              <p id="text5" @click="r2_text">select</p>
              <p id="text6" @click="r3_text">select</p>
              <div id="c1" class="page__light"></div>
              <div id="c2" class="page__dark"></div>
            </div>
          </div>

          <!-- Performance -->
          <div class="page page--3" v-show="currentPage === 3">
            <div class="page__romeo1_juliet1" id="p1"></div>
            <div class="page__romeo1_juliet2" id="p2"></div>
            <div class="page__romeo1_juliet3" id="p3"></div>
            <div class="page__romeo2_juliet1" id="p4"></div>
            <div class="page__romeo2_juliet2" id="p5"></div>
            <div class="page__romeo2_juliet3" id="p6"></div>
            <div class="page__romeo3_juliet1" id="p7"></div>
            <div class="page__romeo3_juliet2" id="p8"></div>
            <div class="page__romeo3_juliet3" id="p9"></div>
            <div class="page__performance_bg"></div>
          </div>

          <!-- Navagation -->
          <!-- <div class="green-room__nav">
            <button v-show="currentPage > 0 && currentPage !== 9" @click="prevPage"
              class="i-btn i-btn--back">Back</button>
            <button v-if="currentPage < 9" @click="nextPage" class="i-btn i-btn--next">Next</button>
          </div> -->
        </section>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    Howl
  } from 'howler';


  export default {
    name: 'app',
    components: {},
    data: function () {
      return {
        username: '',
        hover0: false,
        hover: false,
        hover2: false,
        hover3: false,
        juliet_value: null,
        currentPage: 0,
        currentSoundId: null,
        audio: new Howl({
          src: ['audio/green-room.mp3'],
          sprite: {
            click: [0, 192],
            juliet1: [196, 69985],
            juliet2: [70181, 48409],
            juliet3: [118590, 70231],
            romeo1: [188821, 53374],
            romeo2: [242600, 51271],
            romeo3: [293650, 53680],
            romeo1_juliet1: [347748, 123685],
            romeo1_juliet2: [471433, 102997],
            romeo1_juliet3: [573918, 124544],
            romeo2_juliet1: [698462, 121164],
            romeo2_juliet2: [819626, 100404],
            romeo2_juliet3: [919656, 122180],
            romeo3_juliet1: [1041681, 124434],
            romeo3_juliet2: [1165792, 103381],
            romeo3_juliet3: [1268789, 124983],
          },
        }),
      }
    },

    created() {},

    mounted() {

    },

    methods: {
      nextPage() {
        if (this.currentPage < 7) {
          this.currentPage++;
          this.stop();
        }
      },
      prevPage() {
        if (this.currentPage > 0) {
          this.currentPage--;
          this.stop();
        }
      },
      click() {
        this.audio.play('click');
      },

      stop() {
        this.audio.stop();
      },

      juliet1_audio() {
        this.audio.stop();
        this.audio.play('juliet1');
      },

      juliet2_audio() {
        this.audio.stop();
        this.audio.play('juliet2');
      },

      juliet3_audio() {
        this.audio.stop();
        this.audio.play('juliet3');
      },
      romeo1_audio() {
        this.audio.stop();
        this.audio.play('romeo1');
      },

      romeo2_audio() {
        this.audio.stop();
        this.audio.play('romeo2');
      },

      romeo3_audio() {
        this.audio.stop();
        this.audio.play('romeo3');
      },

      intro_close() {
        document.getElementById('intro').style.display = 'none';
        document.getElementById('hide2').style.display = 'block';
        document.getElementById('hide3').style.display = 'block';
        document.getElementById('hide4').style.display = 'block';
      },

      hide_targets() {
        document.getElementById('hide2').style.display = 'none';
        document.getElementById('hide4').style.display = 'none';
      },
      show_targets() {
        document.getElementById('hide2').style.display = 'block';
        document.getElementById('hide4').style.display = 'block';
      },

      juliet_reset() {
        document.getElementById('js1_target').style.display = 'block';
        document.getElementById('js2_target').style.display = 'block';
        document.getElementById('js3_target').style.display = 'block';
        document.getElementById('juliet1_popup').style.display = 'none';
        document.getElementById('juliet2_popup').style.display = 'none';
        document.getElementById('juliet3_popup').style.display = 'none';
        document.getElementById('all').style.display = 'block';
        document.getElementById('c1').style.display = 'block';
        document.getElementById('c2').style.display = 'none';
      },

      romeo_reset() {
        document.getElementById('rs1_target').style.display = 'block';
        document.getElementById('rs2_target').style.display = 'block';
        document.getElementById('rs3_target').style.display = 'block';
        document.getElementById('romeo1_popup').style.display = 'none';
        document.getElementById('romeo2_popup').style.display = 'none';
        document.getElementById('romeo3_popup').style.display = 'none';
        document.getElementById('all').style.display = 'block';
        document.getElementById('c1').style.display = 'block';
        document.getElementById('c2').style.display = 'none';
      },

      answer() {
        var a = document.getElementById('question');
        var b = document.getElementById('answer');

        if (b.style.display === "none") {
          a.style.display = "block";
        } else {
          a.style.display = "none";
          b.style.display = "block";
        }
      },

      j1_selected() {
        var a = document.getElementById('js1');
        var b = document.getElementById('js1_target');
        var c = document.getElementById('js2_target');
        var d = document.getElementById('js3_target');
        var e = document.getElementById('text1');
        var f = document.getElementById('text2');
        var g = document.getElementById('text3');
        var h = document.getElementById('c2');
        var i = document.getElementById('all');

        if (a.style.display === "block") {
          this.juliet1_audio();
          b.style.display = "none";
          c.style.display = "block";
          d.style.display = "block";
          e.style.display = "block";
          f.style.display = "none";
          g.style.display = "none";
          h.style.display = "block";
          i.style.display = "none";


        } else {
          // this.stop();
        }
      },
      j2_selected() {
        var a = document.getElementById('js2');
        var b = document.getElementById('js1_target');
        var c = document.getElementById('js2_target');
        var d = document.getElementById('js3_target');
        var e = document.getElementById('text1');
        var f = document.getElementById('text2');
        var g = document.getElementById('text3');
        var h = document.getElementById('c2');
        var i = document.getElementById('all');

        if (a.style.display === "block") {
          this.juliet2_audio();
          b.style.display = "block";
          c.style.display = "none";
          d.style.display = "block";
          e.style.display = "none";
          f.style.display = "block";
          g.style.display = "none";
          h.style.display = "block";
          i.style.display = "none";


        } else {
          // this.stop();
        }
      },
      j3_selected() {
        var a = document.getElementById('js3');
        var b = document.getElementById('js1_target');
        var c = document.getElementById('js2_target');
        var d = document.getElementById('js3_target');
        var e = document.getElementById('text1');
        var f = document.getElementById('text2');
        var g = document.getElementById('text3');
        var h = document.getElementById('c2');
        var i = document.getElementById('all');

        if (a.style.display === "block") {
          this.juliet3_audio();
          b.style.display = "block";
          c.style.display = "block";
          d.style.display = "none";
          e.style.display = "none";
          f.style.display = "none";
          g.style.display = "block";
          h.style.display = "block";
          i.style.display = "none";

        } else {
          // this.stop();
        }
      },

      j1_text() {
        var a = document.getElementById('juliet1_popup');
        var b = document.getElementById('js1');
        var c = document.getElementById('text1');
        var e = document.getElementById('js1_target');
        var f = document.getElementById('js2_target');
        var g = document.getElementById('js3_target');
        var h = document.getElementById('juliet1_popup');


        if (a.style.display === "block") {
          a.style.display = "none";
        } else {
          this.stop();
          a.style.display = "block";
          b.style.display = "none";
          c.style.display = "none";
          e.style.display = "none";
          f.style.display = "none";
          g.style.display = "none";
          h.style.zIndex = 3;

        }
      },
      j2_text() {
        var a = document.getElementById('juliet2_popup');
        var b = document.getElementById('js2');
        var c = document.getElementById('text2');
        var e = document.getElementById('js1_target');
        var f = document.getElementById('js2_target');
        var g = document.getElementById('js3_target');
        var h = document.getElementById('juliet2_popup');

        if (a.style.display === "block") {
          a.style.display = "none";
        } else {
          this.stop();
          a.style.display = "block";
          b.style.display = "none";
          c.style.display = "none";
          e.style.display = "none";
          f.style.display = "none";
          g.style.display = "none";
          h.style.zIndex = 3;

        }
      },
      j3_text() {
        var a = document.getElementById('juliet3_popup');
        var b = document.getElementById('js3');
        var c = document.getElementById('text3');
        var e = document.getElementById('js1_target');
        var f = document.getElementById('js2_target');
        var g = document.getElementById('js3_target');
        var h = document.getElementById('juliet3_popup');

        if (a.style.display === "block") {
          a.style.display = "none";
        } else {
          this.stop();
          a.style.display = "block";
          b.style.display = "none";
          c.style.display = "none";
          e.style.display = "none";
          f.style.display = "none";
          g.style.display = "none";
          h.style.zIndex = 3;

        }
      },

      j1() {
        var x = document.getElementById('j1');

        if (x.style.display === "none") {
          this.stop();
          document.getElementById('js1').style.display = 'block';
          document.getElementById('js2').style.display = 'none';
          document.getElementById('js3').style.display = 'none';
          document.getElementById('j1').style.display = 'block';
          document.getElementById('j2').style.display = 'none';
          document.getElementById('j3').style.display = 'none';
        } else {
          document.getElementById('text1').style.display = 'block';
          document.getElementById('js1').style.display = 'block';
          document.getElementById('all').style.display = 'none';
          document.getElementById('j2').style.display = 'none';
          document.getElementById('j3').style.display = 'none';
          document.getElementById('js2').style.display = 'none';
          document.getElementById('js3').style.display = 'none';
        }
      },

      j2() {
        var x = document.getElementById('j2');

        if (x.style.display === "none") {
          document.getElementById('js1').style.display = 'none';
          document.getElementById('js2').style.display = 'block';
          document.getElementById('js3').style.display = 'none';
          document.getElementById('j1').style.display = 'none';
          document.getElementById('j2').style.display = 'block';
          document.getElementById('j3').style.display = 'none';
        } else {
          document.getElementById('js2').style.display = 'block';
          document.getElementById('all').style.display = 'none';
          document.getElementById('j1').style.display = 'none';
          document.getElementById('j3').style.display = 'none';
          document.getElementById('js1').style.display = 'none';
          document.getElementById('js3').style.display = 'none';
        }
      },

      j3() {
        var x = document.getElementById('j3');

        if (x.style.display === "none") {
          document.getElementById('js1').style.display = 'none';
          document.getElementById('js2').style.display = 'none';
          document.getElementById('js3').style.display = 'block';
          document.getElementById('j1').style.display = 'none';
          document.getElementById('j2').style.display = 'none';
          document.getElementById('j3').style.display = 'block';
        } else {
          document.getElementById('js3').style.display = 'block';
          document.getElementById('all').style.display = 'none';
          document.getElementById('j1').style.display = 'none';
          document.getElementById('j2').style.display = 'none';
          document.getElementById('js1').style.display = 'none';
          document.getElementById('js2').style.display = 'none';
        }
      },


      r1_text() {
        var a = document.getElementById('romeo1_popup');
        var b = document.getElementById('rs1');
        var c = document.getElementById('text4');
        var e = document.getElementById('rs1_target');
        var f = document.getElementById('rs2_target');
        var g = document.getElementById('rs3_target');
        var h = document.getElementById('romeo1_popup');


        if (a.style.display === "block") {
          a.style.display = "none";
        } else {
          this.stop();
          a.style.display = "block";
          b.style.display = "none";
          c.style.display = "none";
          e.style.display = "none";
          f.style.display = "none";
          g.style.display = "none";
          h.style.zIndex = 3;

        }
      },
      r2_text() {
        var a = document.getElementById('romeo2_popup');
        var b = document.getElementById('rs2');
        var c = document.getElementById('text5');
        var e = document.getElementById('rs1_target');
        var f = document.getElementById('rs2_target');
        var g = document.getElementById('rs3_target');
        var h = document.getElementById('romeo2_popup');

        if (a.style.display === "block") {
          a.style.display = "none";
        } else {
          this.stop();
          a.style.display = "block";
          b.style.display = "none";
          c.style.display = "none";
          e.style.display = "none";
          f.style.display = "none";
          g.style.display = "none";
          h.style.zIndex = 3;

        }
      },
      r3_text() {
        var a = document.getElementById('romeo3_popup');
        var b = document.getElementById('rs3');
        var c = document.getElementById('text6');
        var e = document.getElementById('rs1_target');
        var f = document.getElementById('rs2_target');
        var g = document.getElementById('rs3_target');
        var h = document.getElementById('romeo3_popup');

        if (a.style.display === "block") {
          a.style.display = "none";
        } else {
          this.stop();
          a.style.display = "block";
          b.style.display = "none";
          c.style.display = "none";
          e.style.display = "none";
          f.style.display = "none";
          g.style.display = "none";
          h.style.zIndex = 3;

        }
      },

      r1() {
        var x = document.getElementById('r1');

        if (x.style.display === "none") {
          this.stop();
          document.getElementById('rs1').style.display = 'block';
          document.getElementById('rs2').style.display = 'none';
          document.getElementById('rs3').style.display = 'none';
          document.getElementById('r1').style.display = 'block';
          document.getElementById('r2').style.display = 'none';
          document.getElementById('r3').style.display = 'none';
        } else {

          document.getElementById('text4').style.display = 'block';
          document.getElementById('rs1').style.display = 'block';
          document.getElementById('all').style.display = 'none';
          document.getElementById('r2').style.display = 'none';
          document.getElementById('r3').style.display = 'none';
          document.getElementById('rs2').style.display = 'none';
          document.getElementById('rs3').style.display = 'none';
        }
      },

      r2() {
        var x = document.getElementById('r2');

        if (x.style.display === "none") {
          document.getElementById('rs1').style.display = 'none';
          document.getElementById('rs2').style.display = 'block';
          document.getElementById('rs3').style.display = 'none';
          document.getElementById('r1').style.display = 'none';
          document.getElementById('r2').style.display = 'block';
          document.getElementById('r3').style.display = 'none';
        } else {
          document.getElementById('rs2').style.display = 'block';
          document.getElementById('all').style.display = 'none';
          document.getElementById('r1').style.display = 'none';
          document.getElementById('r3').style.display = 'none';
          document.getElementById('rs1').style.display = 'none';
          document.getElementById('rs3').style.display = 'none';
        }
      },

      r3() {
        var x = document.getElementById('r3');

        if (x.style.display === "none") {
          document.getElementById('rs1').style.display = 'none';
          document.getElementById('rs2').style.display = 'none';
          document.getElementById('rs3').style.display = 'block';
          document.getElementById('r1').style.display = 'none';
          document.getElementById('r2').style.display = 'none';
          document.getElementById('r3').style.display = 'block';
        } else {
          document.getElementById('rs3').style.display = 'block';
          document.getElementById('all').style.display = 'none';
          document.getElementById('r1').style.display = 'none';
          document.getElementById('r2').style.display = 'none';
          document.getElementById('rs1').style.display = 'none';
          document.getElementById('rs2').style.display = 'none';
        }
      },

      r1_selected() {
        var a = document.getElementById('rs1');
        var b = document.getElementById('rs1_target');
        var c = document.getElementById('rs2_target');
        var d = document.getElementById('rs3_target');
        var e = document.getElementById('text4');
        var f = document.getElementById('text5');
        var g = document.getElementById('text6');
        var h = document.getElementById('c2');
        var i = document.getElementById('all');

        if (a.style.display === "block") {
          this.romeo1_audio();
          b.style.display = "none";
          c.style.display = "block";
          d.style.display = "block";
          e.style.display = "block";
          f.style.display = "none";
          g.style.display = "none";
          h.style.display = "block";
          i.style.display = "none";


        } else {
          // this.stop();
        }
      },
      r2_selected() {
        var a = document.getElementById('rs2');
        var b = document.getElementById('rs1_target');
        var c = document.getElementById('rs2_target');
        var d = document.getElementById('rs3_target');
        var e = document.getElementById('text4');
        var f = document.getElementById('text5');
        var g = document.getElementById('text6');
        var h = document.getElementById('c2');
        var i = document.getElementById('all');

        if (a.style.display === "block") {
          this.romeo2_audio();
          b.style.display = "block";
          c.style.display = "none";
          d.style.display = "block";
          e.style.display = "none";
          f.style.display = "block";
          g.style.display = "none";
          h.style.display = "block";
          i.style.display = "none";


        } else {
          // this.stop();
        }
      },
      r3_selected() {
        var a = document.getElementById('rs3');
        var b = document.getElementById('rs1_target');
        var c = document.getElementById('rs2_target');
        var d = document.getElementById('rs3_target');
        var e = document.getElementById('text4');
        var f = document.getElementById('text5');
        var g = document.getElementById('text6');
        var h = document.getElementById('c2');
        var i = document.getElementById('all');

        if (a.style.display === "block") {
          this.romeo3_audio();
          b.style.display = "block";
          c.style.display = "block";
          d.style.display = "none";
          e.style.display = "none";
          f.style.display = "none";
          g.style.display = "block";
          h.style.display = "block";
          i.style.display = "none";

        } else {
          // this.stop();
        }
      },

      performance() {

        var juliet_value = this.juliet_value;
        var romeo_value = this.romeo_value;

        if (romeo_value == 1 && juliet_value == 1) {
          this.audio.play('romeo1_juliet1');
          document.getElementById('p1').style.display = "block";
        }
        if (romeo_value == 1 && juliet_value == 2) {
          this.audio.play('romeo1_juliet2');
          document.getElementById('p2').style.display = "block";
        }
        if (romeo_value == 1 && juliet_value == 3) {
          this.audio.play('romeo1_juliet3');
          document.getElementById('p3').style.display = "block";
        }
        if (romeo_value == 2 && juliet_value == 1) {
          this.audio.play('romeo2_juliet1');
          document.getElementById('p4').style.display = "block";
        }
        if (romeo_value == 2 && juliet_value == 2) {
          this.audio.play('romeo2_juliet2');
          document.getElementById('p5').style.display = "block";
        }
        if (romeo_value == 2 && juliet_value == 3) {
          this.audio.play('romeo2_juliet3');
          document.getElementById('p6').style.display = "block";
        }
        if (romeo_value == 3 && juliet_value == 1) {
          this.audio.play('romeo3_juliet1');
          document.getElementById('p7').style.display = "block";
        }
        if (romeo_value == 3 && juliet_value == 2) {
          this.audio.play('romeo3_juliet2');
          document.getElementById('p8').style.display = "block";
        }
        if (romeo_value == 3 && juliet_value == 3) {
          this.audio.play('romeo3_juliet3');
          document.getElementById('p9').style.display = "block";
        }
      },

      close1() {
        var x = document.getElementById('juliet');

        if (x.style.display === "block") {
          x.style.display = "block";
        } else {
          x.style.display = "none";
          document.getElementById('js1_target').style.display = "block";
          document.getElementById('js2_target').style.display = "block";
          document.getElementById('js3_target').style.display = "block";
          document.getElementById('c1').style.display = "block";
          document.getElementById('c2').style.display = "none";
        }
      },

      close2() {
        var x = document.getElementById('romeo');

        if (x !== null) {
          if (x.style.display === "block") {
            x.style.display = "block";
          } else {
            x.style.display = "none";
            document.getElementById('rs1_target').style.display = "block";
            document.getElementById('rs2_target').style.display = "block";
            document.getElementById('rs3_target').style.display = "block";
            document.getElementById('c1').style.display = "block";
            document.getElementById('c2').style.display = "none";
          }
        }
      },
    }
  }
</script>

<style lang="scss">
  @import "style";

  .green-room {
    margin: 0;
    padding: 0;
    width: fluid(725px);
    height: fluid(380px);

    &__nav {
      position: absolute;
      right: fluid(110px);
      bottom: fluid(10px);
      width: fluid(180px);

      button {
        font-family: $cursive;
        text-transform: uppercase;
        cursor: pointer;
      }
    }

    &__padding {
      position: relative;
      padding: 0 0 #{(380/725)*100%};
    }

    &__stage {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .page-area {
    width: 100%;
    height: 100%;
    position: absolute;
    margin: auto;

    #text {
      cursor: pointer;
      display: none;
      position: absolute;
      right: fluid(155px);
      bottom: fluid(105px);
      color: white;
      text-transform: uppercase;
      font-family: $cursive;
      font-size: fluid(20px);
    }

    #text1,
    #text2,
    #text3,
    #text4,
    #text5,
    #text6 {
      cursor: pointer;
      display: none;
      position: absolute;
      right: fluid(155px);
      bottom: fluid(105px);
      color: white;
      text-transform: uppercase;
      font-family: $cursive;
      font-size: fluid(20px);
      z-index: 2;
    }
  }

  .page {
    width: fluid(725px);
    height: fluid(380px);
    background: $burgundy;

    &__title {
      font-weight: 300;
      color: #000;
      margin: fluid(10px) auto;
      font-size: fluid(18.5px);
      line-height: 1.2em;
      font-weight: 700;
      width: 90%;
    }

    &__sub_title {
      text-align: center;
      width: 100%;
      text-transform: uppercase;
      color: #000;
      font-size: fluid(12px);
      text-transform: uppercase;
      margin: 0;
      padding: fluid(10px) 0px;
    }

    &__background {
      width: 100%;
      height: 100%;
      background-image: url('~@/assets/img/scene0--background.svg');
      @include image;
    }

    &__performance_bg {
      position: absolute;
      top: fluid(-10px);
      width: fluid(725px);
      height: fluid(398px);
      background-image: url('~@/assets/img/scene3--background.svg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    &__romeo1_juliet1,
    &__romeo1_juliet2,
    &__romeo1_juliet3,
    &__romeo2_juliet1,
    &__romeo2_juliet2,
    &__romeo2_juliet3,
    &__romeo3_juliet1,
    &__romeo3_juliet2,
    &__romeo3_juliet3 {
      display: none;
      position: absolute;
      top: fluid(100px);
      left: fluid(205px);
      width: fluid(215px);
      height: fluid(215px);
      @include image;
      z-index: 10;
    }

    &__romeo1_juliet1 {
      background-image: url('~@/assets/img/scene3--romeo1_juliet1.svg');
    }

    &__romeo1_juliet2 {
      background-image: url('~@/assets/img/scene3--romeo1_juliet2.svg');
    }

    &__romeo1_juliet3 {
      background-image: url('~@/assets/img/scene3--romeo1_juliet3.svg');
    }

    &__romeo2_juliet1 {
      background-image: url('~@/assets/img/scene3--romeo2_juliet1.svg');
    }

    &__romeo2_juliet2 {
      background-image: url('~@/assets/img/scene3--romeo2_juliet2.svg');
    }

    &__romeo2_juliet3 {
      background-image: url('~@/assets/img/scene3--romeo2_juliet3.svg');
    }

    &__romeo3_juliet1 {
      background-image: url('~@/assets/img/scene3--romeo3_juliet1.svg');
    }

    &__romeo3_juliet2 {
      background-image: url('~@/assets/img/scene3--romeo3_juliet2.svg');
    }

    &__romeo3_juliet3 {
      background-image: url('~@/assets/img/scene3--romeo3_juliet3.svg');
    }

    &__light,
    &__dark {
      position: absolute;
      width: fluid(725px);
      height: fluid(380px);
      @include image;
      border: 1px solid #000;
      z-index: 1;
    }

    &__light {
      background-image: url('~@/assets/img/scene1--curtains.svg');
    }

    &__dark {
      background-image: url('~@/assets/img/scene1--curtains2.svg');
    }

    &__juliets,
    &__juliet_1_missing,
    &__juliet_2_missing,
    &__juliet_3_missing,
    &__romeos,
    &__romeo_1_missing,
    &__romeo_2_missing,
    &__romeo_3_missing {
      display: block;
      position: absolute;
      width: fluid(725px);
      height: fluid(380px);
      @include image;
      border: 1px solid #000;
      z-index: 2;
    }

    &__juliets {
      background-image: url('~@/assets/img/scene1--juliets_nomen.svg');
    }

    &__juliet_1_missing {
      background-image: url('~@/assets/img/scene1--juliet_1_nomen.svg');
    }

    &__juliet_2_missing {
      background-image: url('~@/assets/img/scene1--juliet_2_nomen.svg');
    }

    &__juliet_3_missing {
      background-image: url('~@/assets/img/scene1--juliet_3_nomen.svg');
    }

    &__romeos {
      background-image: url('~@/assets/img/scene2--romeos_nowomen.svg');
    }

    &__romeo_1_missing {
      background-image: url('~@/assets/img/scene2--romeo_1_nowomen.svg');
    }

    &__romeo_2_missing {
      background-image: url('~@/assets/img/scene2--romeo_2_nowomen.svg');
    }

    &__romeo_3_missing {
      background-image: url('~@/assets/img/scene2--romeo_3_nowomen.svg');
    }

    &__juliet_stage1,
    &__juliet_stage2,
    &__juliet_stage3,
    &__romeo_stage1,
    &__romeo_stage2,
    &__romeo_stage3 {
      display: none;
      position: absolute;
      top: fluid(100px);
      left: fluid(300px);
      width: fluid(101px);
      height: fluid(203px);
      @include image;
      z-index: 10;
    }

    &__juliet_stage1 {
      background-image: url('~@/assets/img/scene1--juliet_selected1.svg');
    }

    &__juliet_stage2 {
      background-image: url('~@/assets/img/scene1--juliet_selected2.svg');
    }

    &__juliet_stage3 {
      background-image: url('~@/assets/img/scene1--juliet_selected3.svg');
    }

    &__romeo_stage1 {
      background-image: url('~@/assets/img/scene2--romeo_selected1.svg');
    }

    &__romeo_stage2 {
      background-image: url('~@/assets/img/scene2--romeo_selected2.svg');
    }

    &__romeo_stage3 {
      background-image: url('~@/assets/img/scene2--romeo_selected3.svg');
    }

    &__targets {

      &--green_room_info,
      &--you_cant_take,
      &--book,
      &--flyer,
      &--audition,
      &--juliet1,
      &--juliet2,
      &--juliet3,
      &--romeo1,
      &--romeo2,
      &--romeo3 {
        cursor: pointer;
        position: absolute;
        // background: #00000090;
        z-index: 9;
      }

      &--green_room_info {
        z-index: 1;
        left: fluid(161px);
        bottom: fluid(120px);
        width: fluid(80px);
        height: fluid(65px);
        clip-path: polygon(1% 10%, 100% 1%, 89% 100%, 2% 93%);
      }

      &--you_cant_take {
        left: fluid(176px);
        top: fluid(45px);
        width: fluid(105px);
        height: fluid(88px);
        clip-path: polygon(3% 0, 99% 10%, 88% 94%, 10% 95%);
      }

      &--book {
        right: fluid(200px);
        bottom: fluid(110px);
        width: fluid(55px);
        height: fluid(45px);
        clip-path: polygon(10% 0%, 90% 13%, 69% 100%, 0% 90%);
        z-index: 11;
      }

      &--flyer {
        right: fluid(35px);
        top: fluid(75px);
        width: fluid(40px);
        height: fluid(45px);
        clip-path: polygon(15% 1%, 90% 3%, 89% 98%, 7% 89%);
      }

      &--audition {
        right: fluid(110px);
        top: fluid(80px);
        width: fluid(105px);
        height: fluid(48px);
        clip-path: polygon(3% 0, 85% 10%, 81% 73%, 10% 75%);
      }

      &--juliet1 {
        display: none;
        left: fluid(102px);
        bottom: fluid(0px);
        width: fluid(58px);
        height: fluid(102px);
      }

      &--juliet2 {
        display: none;
        left: fluid(165px);
        bottom: fluid(0px);
        width: fluid(50px);
        height: fluid(91px);
      }

      &--juliet3 {
        display: none;
        left: fluid(222px);
        bottom: fluid(0px);
        width: fluid(50px);
        height: fluid(94px);
      }

      &--romeo1 {
        display: none;
        right: fluid(213px);
        bottom: fluid(0px);
        width: fluid(62px);
        height: fluid(102px);
      }

      &--romeo2 {
        display: none;
        right: fluid(155px);
        bottom: fluid(0px);
        width: fluid(58px);
        height: fluid(99px);
      }

      &--romeo3 {
        display: none;
        right: fluid(95px);
        bottom: fluid(0px);
        width: fluid(59px);
        height: fluid(94px);
      }
    }

    &__popup {
      display: flex;
      position: absolute;
      justify-content: center;
      align-items: center;
      height: fluid(380px);
      width: 100%;
      opacity: 1;

      &--green_room_info {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 55%;
        height: 75%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: 12;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                color: $burgundy;
                font-size: fluid(24px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(5px);
              }
            }

            .details {
              width: 100%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  font-weight: 700;
                }

                &:hover {
                  color: lighten($burgundy, 20%);
                }
              }
            }
          }
        }

        .content_answer {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                color: $burgundy;
                font-size: fluid(24px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(5px);
              }
            }

            .details {
              width: 90%;
              height: auto;
              margin: 30px auto;

              .subtitle {
                font-family: $cursive;
                text-align: center;
                font-size: fluid(24px);
                font-weight: 700;
              }

              p {
                font-size: fluid(18px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  font-weight: 700;
                }
              }

              .button_box {
                display: flex;
                justify-content: center;
                width: 90%;
                margin: fluid(20px) auto;

                .close {
                  cursor: pointer;
                  display: flex;
                  justify-content: center;
                  width: fluid(90px);
                  height: fluid(30px);
                  background-image: url('~@/assets/img/scene1--button.svg');
                  @include image;

                  p {
                    font-family: $cursive;
                    font-size: fluid(20px);
                    line-height: fluid(28px);
                    color: $burgundy;
                    font-weight: 700;
                    margin: 0;
                    padding: 0;
                  }

                }
              }
            }
          }
        }
      }

      &--you_cant_take {
        width: 79%;
        height: 66%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: 10;
        pointer-events: none;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;
          margin: 20px auto;

          .content_image {
            width: fluid(200px);
            height: fluid(203px);
            background-image: url('~@/assets/img/scene0--you_cant.svg');
            @include image;
          }

          .text_box {
            width: 50%;
            height: auto;

            .title {
              min-width: 100%;
              height: auto;

              p {
                text-align: left;
                font-family: $cursive;
                color: $burgundy;
                font-size: fluid(24px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(5px);
              }
            }

            .details {
              width: 100%;
              height: auto;

              p {
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(15px);
              }
            }
          }
        }
      }

      &--flyer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 55%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: 10;

        .content {
          display: flex;
          justify-content: space-between;
          width: 90%;
          height: 90%;

          .content_image {
            width: fluid(230px);
            height: fluid(200px);
            background-image: url('~@/assets/img/scene0--flyer.svg');
            @include image;
          }

          .text_box {
            width: 48%;
            height: auto;

            .title {
              width: 100%;
              height: auto;

              p {
                text-align: left;
                font-family: $cursive;
                color: $burgundy;
                font-size: fluid(28px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(5px);
              }
            }

            .details {
              width: 100%;
              height: auto;

              p {
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(15px);
              }
            }
          }
        }
      }

      &--book {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 55%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: 10;

        .content {
          display: flex;
          justify-content: space-between;
          width: 90%;
          height: 90%;

          .content_image {
            width: fluid(230px);
            height: fluid(200px);
            background-image: url('~@/assets/img/scene0--book.svg');
            @include image;
          }

          .text_box {
            width: 48%;
            height: auto;

            .title {
              width: 100%;
              height: auto;

              p {
                text-align: left;
                font-family: $cursive;
                color: $burgundy;
                font-size: fluid(28px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(5px);
              }
            }

            .details {
              width: 100%;
              height: auto;

              p {
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(15px);
              }
            }
          }
        }
      }

      &--juliet_audition {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 52%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: 99;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .content_image {
            width: fluid(200px);
            height: fluid(203px);
            background-image: url('~@/assets/img/scene0--you_cant.svg');
            @include image;
          }

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              display: flex;
              justify-content: space-between;
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                color: $burgundy;
                font-size: fluid(24px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(10px);
              }

              #close {
                cursor: pointer;
              }
            }

            .details {
              width: 98%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  color: lighten($burgundy, 20%);
                }
              }
            }
          }
        }
      }

      &--juliet1_popup {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 52%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: -1;
        margin: 12% auto;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .content_image {
            width: fluid(150px);
            height: fluid(150px);
            background-image: url('~@/assets/img/scene1--juliet_selected1.svg');
            @include image;
          }

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              display: flex;
              justify-content: space-between;
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                font-size: fluid(30px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(10px);
              }

              #close {
                cursor: pointer;
              }
            }

            .details {
              width: 98%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  color: lighten($burgundy, 20%);
                }
              }
            }

            .button_box {
              display: flex;
              justify-content: space-between;
              width: 90%;
              margin: fluid(15px) auto;

              .back,
              .continue {
                cursor: pointer;
                display: flex;
                justify-content: center;
                width: fluid(90px);
                height: fluid(30px);
                background-image: url('~@/assets/img/scene1--button.svg');
                @include image;
                z-index: 0;

                p {
                  font-family: $cursive;
                  font-size: fluid(16px);
                  line-height: fluid(28px);
                  color: $burgundy;
                  font-weight: 700;
                  margin: 0;
                  padding: 0;
                }

              }
            }
          }
        }
      }

      &--juliet2_popup {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 52%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: -1;
        margin: 12% auto;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .content_image {
            width: fluid(150px);
            height: fluid(150px);
            background-image: url('~@/assets/img/scene1--juliet_selected2.svg');
            @include image;
          }

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              display: flex;
              justify-content: space-between;
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                font-size: fluid(30px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(10px);
              }

              #close {
                cursor: pointer;
              }
            }

            .details {
              width: 98%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  color: lighten($burgundy, 20%);
                }
              }
            }

            .button_box {
              display: flex;
              justify-content: space-between;
              width: 90%;
              margin: fluid(15px) auto;

              .back,
              .continue {
                cursor: pointer;
                display: flex;
                justify-content: center;
                width: fluid(90px);
                height: fluid(30px);
                background-image: url('~@/assets/img/scene1--button.svg');
                @include image;
                z-index: 0;

                p {
                  font-family: $cursive;
                  font-size: fluid(16px);
                  line-height: fluid(28px);
                  color: $burgundy;
                  font-weight: 700;
                  margin: 0;
                  padding: 0;
                }

              }
            }
          }
        }
      }

      &--juliet3_popup {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 52%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: -1;
        margin: 12% auto;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .content_image {
            width: fluid(150px);
            height: fluid(150px);
            background-image: url('~@/assets/img/scene1--juliet_selected3.svg');
            @include image;
          }

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              display: flex;
              justify-content: space-between;
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                font-size: fluid(30px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(10px);
              }

              #close {
                cursor: pointer;
              }
            }

            .details {
              width: 98%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  color: lighten($burgundy, 20%);
                }
              }
            }

            .button_box {
              display: flex;
              justify-content: space-between;
              width: 90%;
              margin: fluid(15px) auto;

              .back,
              .continue {
                cursor: pointer;
                display: flex;
                justify-content: center;
                width: fluid(90px);
                height: fluid(30px);
                background-image: url('~@/assets/img/scene1--button.svg');
                @include image;
                z-index: 0;

                p {
                  font-family: $cursive;
                  font-size: fluid(16px);
                  line-height: fluid(28px);
                  color: $burgundy;
                  font-weight: 700;
                  margin: 0;
                  padding: 0;
                }

              }
            }
          }
        }
      }

      &--romeo_audition {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 40%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: 10;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .content_image {
            width: fluid(200px);
            height: fluid(203px);
            background-image: url('~@/assets/img/scene0--you_cant.svg');
            @include image;
          }

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              display: flex;
              justify-content: space-between;
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                color: $burgundy;
                font-size: fluid(24px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(10px);
              }

              #close {
                cursor: pointer;
              }
            }

            .details {
              width: 98%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  color: lighten($burgundy, 20%);
                }
              }
            }
          }
        }
      }

      &--romeo1_popup {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 52%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: 0;
        margin: 165px auto;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .content_image {
            width: fluid(150px);
            height: fluid(150px);
            background-image: url('~@/assets/img/scene2--romeo_selected1.svg');
            @include image;
          }

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              display: flex;
              justify-content: space-between;
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                font-size: fluid(30px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(10px);
              }

              #close {
                cursor: pointer;
              }
            }

            .details {
              width: 98%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  color: lighten($burgundy, 20%);
                }
              }
            }

            .button_box {
              display: flex;
              justify-content: space-between;
              width: 90%;
              margin: fluid(15px) auto;

              .back,
              .continue {
                cursor: pointer;
                display: flex;
                justify-content: center;
                width: fluid(90px);
                height: fluid(30px);
                background-image: url('~@/assets/img/scene1--button.svg');
                @include image;
                z-index: 99;

                p {
                  font-family: $cursive;
                  font-size: fluid(16px);
                  line-height: fluid(28px);
                  color: $burgundy;
                  font-weight: 700;
                  margin: 0;
                  padding: 0;
                }

              }
            }
          }
        }
      }

      &--romeo2_popup {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 52%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: -1;
        margin: 165px auto;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .content_image {
            width: fluid(150px);
            height: fluid(150px);
            background-image: url('~@/assets/img/scene2--romeo_selected2.svg');
            @include image;
          }

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              display: flex;
              justify-content: space-between;
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                font-size: fluid(30px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(10px);
              }

              #close {
                cursor: pointer;
              }
            }

            .details {
              width: 98%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  color: lighten($burgundy, 20%);
                }
              }
            }

            .button_box {
              display: flex;
              justify-content: space-between;
              width: 90%;
              margin: fluid(15px) auto;

              .back,
              .continue {
                cursor: pointer;
                display: flex;
                justify-content: center;
                width: fluid(90px);
                height: fluid(30px);
                background-image: url('~@/assets/img/scene1--button.svg');
                @include image;
                z-index: 99;

                p {
                  font-family: $cursive;
                  font-size: fluid(16px);
                  line-height: fluid(28px);
                  color: $burgundy;
                  font-weight: 700;
                  margin: 0;
                  padding: 0;
                }

              }
            }
          }
        }
      }

      &--romeo3_popup {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 52%;
        border-radius: fluid(30px);
        background-color: white;
        -webkit-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        -moz-box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        box-shadow: -4px 4px 0px 0px rgba(214, 198, 129, 1);
        z-index: -1;
        margin: 165px auto;

        .content {
          display: flex;
          justify-content: space-between;
          width: 80%;
          height: 80%;

          .content_image {
            width: fluid(150px);
            height: fluid(150px);
            background-image: url('~@/assets/img/scene2--romeo_selected3.svg');
            @include image;
          }

          .text_box {
            width: 100%;
            height: 100%;

            .title {
              display: flex;
              justify-content: space-between;
              width: 100%;
              height: auto;

              p {
                text-align: center;
                font-family: $cursive;
                font-size: fluid(30px);
                font-weight: 700;
                margin: 0;
                padding: 0;
                margin-bottom: fluid(10px);
              }

              #close {
                cursor: pointer;
              }
            }

            .details {
              width: 98%;
              height: auto;

              p {
                cursor: pointer;
                font-size: fluid(12px);
                margin: 0;
                padding: 0;
                margin-bottom: fluid(8px);

                span {
                  color: lighten($burgundy, 20%);
                }
              }
            }

            .button_box {
              display: flex;
              justify-content: space-between;
              width: 90%;
              margin: fluid(15px) auto;

              .back,
              .continue {
                cursor: pointer;
                display: flex;
                justify-content: center;
                width: fluid(90px);
                height: fluid(30px);
                background-image: url('~@/assets/img/scene1--button.svg');
                @include image;
                z-index: 99;

                p {
                  font-family: $cursive;
                  font-size: fluid(16px);
                  line-height: fluid(28px);
                  color: $burgundy;
                  font-weight: 700;
                  margin: 0;
                  padding: 0;
                }

              }
            }
          }
        }
      }
    }
  }



  .i-btn {
    appearance: none;
    border: 0;
    background: transparent;
    font-weight: 600;
    margin: auto;
    font-size: fluid(14px);
    flex: 0 0 auto;
    z-index: 99;

    &:before {
      content: '';
      width: fluid(25px);
      height: fluid(25px);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      display: block;
      margin: 0 auto;
    }

    &--back {
      float: left;
      justify-self: start;

      &:before {
        background-image: url('~@/assets/img/button_arrow_l.svg');
      }
    }

    &--next {
      float: right;
      z-index: 99;

      &:before {
        background-image: url('~@/assets/img/button_arrow_r.svg');
      }
    }
  }

  #question {
    display: block;
  }

  #answer {
    display: none;
  }
</style>